import { ArticleType } from '@wix/ambassador-cc-kb-server-v1-article-translation/types';
import React, { FC, useCallback, useEffect, useState } from 'react';

import { followArticle, isFollowingArticle, unfollowArticle } from '../../../common/api/articleFollowClient';
import { HelpCenterVoteableArticle } from '../../types';
import { FeatureRequestVoteButton } from './FeatureRequestVoteButton';
import { KnownIssueVoteButton } from './KnownIssueVoteButton';

export interface ArticleVoteButtonProps {
  article: HelpCenterVoteableArticle;
}

export const ArticleVoteButton: FC<ArticleVoteButtonProps> = ({ article }) => {
  const [isVoted, setIsVoted] = useState<boolean>();
  const [isVotedInCurrentSession, setIsVotedInCurrentSession] = useState<boolean>(false);

  useEffect(() => {
    const fetchVoteStatus = async () => {
      const currentStatus = await isFollowingArticle(article.id, article.locale);
      setIsVoted(currentStatus);
    };

    fetchVoteStatus();
  }, [article]);

  const onVote = useCallback(() => {
    const voted = !isVoted;

    if (voted) {
      followArticle(article.id, article.locale);
    } else {
      unfollowArticle(article.id, article.locale);
    }

    setIsVoted(voted);
    setIsVotedInCurrentSession(voted);
  }, [article, isVoted, setIsVoted]);

  if (isVoted === undefined) {
    return null;
  }

  return (
    <>
      {article.type === ArticleType.FEATURE_REQUEST ? (
        <FeatureRequestVoteButton
          article={article}
          onVote={onVote}
          isVoted={isVoted}
          isVotedInCurrentSession={isVotedInCurrentSession}
        />
      ) : null}
      {article.type === ArticleType.KNOWN_ISSUE ? (
        <KnownIssueVoteButton
          article={article}
          onVote={onVote}
          isVoted={isVoted}
          isVotedInCurrentSession={isVotedInCurrentSession}
        />
      ) : null}
    </>
  );
};
